import { FloaterLocation } from '../../types/state'
import { getCookie } from '../utilities/cookies'
import { getLocalStorageValue, setLocalStorage } from '../utilities/storage'
import { getSessionKey, SESSION_KEY } from './history'

export type Metadata = {
    uid: number
    quickReply?: {
        open?: boolean
        minimized?: boolean
        lastInteraction?: number
        location?: FloaterLocation
    }
}
export type Recipient = {
    metadata: Metadata
    version: number
}
export type Recipients = Record<string, Recipient>

const PM_SESSION_PREFIX = 'PM_SESSIONS_'

export const removeOldPMSessions = () => {
    if (typeof window === 'undefined') return
    if (!localStorage) return

    Object.keys(localStorage).map((key) => {
        if (key.startsWith('PM_SESSIONS_') && !key.match(/PM_SESSIONS_\d+/g)) {
            localStorage.removeItem(key)
        }
    })
}

export const getRecipients = (): Recipients => {
    if (typeof window === 'undefined') return
    if (!localStorage) return
    const PM_SESSIONS = getSessionKey(PM_SESSION_PREFIX)

    removeOldPMSessions()
    const sessions = getLocalStorageValue(PM_SESSIONS)

    if (!sessions) {
        return {}
    }

    try {
        return JSON.parse(sessions)
    } catch (error) {
        console.error(error)
        setLocalStorage(PM_SESSIONS, JSON.stringify({}))
        return {}
    }
}

const migrateSession = (session: any) => {
    // const { version = 1 } = session
    // place to properly migrate from old local storage message data
    return {
        ...session,
        version: 2,
    }
}

export const setRecipient = (slug: string, metadata: Partial<Metadata>) => {
    if (typeof window === 'undefined') return
    if (!localStorage) return
    if (!slug || !metadata || typeof metadata !== 'object') return

    const id = Number(getCookie(SESSION_KEY))
    // must be logged in to set a recipient
    if (!id) return
    // console.log('[setRecipient]', { slug, metadata })
    const PM_SESSIONS = getSessionKey(PM_SESSION_PREFIX)

    const normalized = slug.toLowerCase()
    const sessionsStr = getLocalStorageValue(PM_SESSIONS) || JSON.stringify({})
    const sessions: Recipients = JSON.parse(sessionsStr)
    const { [normalized]: existing = {} as Recipient, ...remaining } = sessions
    const { metadata: existingMetadata = {} as Metadata } =
        migrateSession(existing)
    const merged: Recipients = {
        [normalized]: {
            ...existing,
            metadata: {
                ...existingMetadata,
                ...metadata,
            },
        },
        ...remaining,
    }

    setLocalStorage(PM_SESSIONS, JSON.stringify(merged))
}

export const forgetRecipient = (slug: string) => {
    if (typeof window === 'undefined') return
    if (!localStorage) return
    const PM_SESSIONS = getSessionKey(PM_SESSION_PREFIX)

    const sessionsStr = getLocalStorageValue(PM_SESSIONS) || JSON.stringify({})
    const sessions: Recipients = JSON.parse(sessionsStr)
    const { [slug.toLowerCase()]: _, ...remaining } = sessions
    setLocalStorage(PM_SESSIONS, JSON.stringify(remaining))
}
